<template>
  <div class="goods" ref="goods">
    <img class="img" :src="goods.src" :alt="goods.src" :style="{height}">
    <div class="footer">
      <p class="title t-ellipsis">{{goods.title}}</p>
      <p class="desc t-ellipsis">{{goods.desc}}</p>
      <div class="last flex flex-between flex-cross-center">
        <span class="price">￥{{goods.price}}</span>
        <span class="link">立即购买</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    goods: Object
  },
  data () {
    return {
      height: ''
    }
  },
  computed: {
    ...mapGetters(['viewport'])
  },
  methods: {
    calcHeight () {
      if (this.$refs.goods) {
        this.height = lib.flexible.px2rem(`${this.$refs.goods.clientWidth / this.goods.imgWidth * this.goods.imgHeight}px`)
      }
    }
  },
  watch: {
    'viewport.width': {
      immediate: true,
      handler () {
        this.calcHeight()
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.calcHeight()
    })
  }
}
</script>
<style lang="stylus" scoped>
@import "./var.styl"
.goods
  width 96%
  margin 2%
  /*box-shadow 1px 1px 5px 1px rgba(0, 0, 0, 0.15)*/
  border-radius 2px
  border 1px solid rgba(0,0,0,.1)
.img
  width 100%
.footer
  padding 0 12px 4px
.title
  margin 4px 0
  color $color-text-highlight
.desc
  margin 4px 0
  color $color-text-primary
.last
  padding 4px 0
.price
  color $color-primary
.link
  padding 4px 8px
  color #8081e7
  background-color lighten(@color, 70%)
  border 1px solid @color
  border-radius 12px
  font-size 12px
  line-height 12px
</style>



// WEBPACK FOOTER //
// GoodItem.vue?32399ef9